(ns frontend.test.alert.view
  (:require [ui.components.alert.view :as alert]))

(defn view
  []
  [:div
   {:class-name "p-4 flex flex-col gap-4 container bg-base-light"}

   [alert/danger
    {:on-click (fn [])}
    [:strong
     {:class-name "block"}
     "There were 2 errors with your submission"]
    [:ul
     {:class-name "flex flex-col gap-2 list-disc px-6 pt-3"}
     [:li "Your password must be at least 8 characters"]
     [:li "Your password must include at least one pro wrestling finishing move"]]]

   [alert/warning
    {:on-click (fn [])}
    [:div
     {:class-name "flex gap-2 items-center"}
     [:strong
      {:class-name "block"}
      "You have no credits left."]
     [:a
      {:href "#"
       :class-name "underline text-warning-light-text font-semibold"}
      "Upgrade your account to add more credits."]]]

   [alert/info
    {:on-click (fn [])}
    [:div
     {:class-name "flex gap-2 items-center"}
     [:strong
      {:class-name "block"}
      "A new software update is available. See what’s new in version 2.0.4."]]]]
)
